const APP_CONFIG = 'APP_CONFIG';

export const getPageConfigInventory = (inventories: any[]) => {
  if (Array.isArray(inventories) && inventories.length > 0) {
    return inventories.find((inv) => inv.widgetData?.widgetType === APP_CONFIG);
  }
  return null;
};
